"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Product = require("./Product");
Object.keys(_Product).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Product[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Product[key];
    }
  });
});
var _Products = require("./Products");
Object.keys(_Products).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Products[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Products[key];
    }
  });
});
var _GoToProduct = require("./GoToProduct");
Object.keys(_GoToProduct).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GoToProduct[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GoToProduct[key];
    }
  });
});
var _ShadePickerDialog = require("./ShadePickerDialog");
Object.keys(_ShadePickerDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ShadePickerDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ShadePickerDialog[key];
    }
  });
});
//# sourceMappingURL=index.js.map